import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
// import colors from '@/styles/color.scss';
import lang from '@blade-sxp/monitor-center/lang/index';
import cascaderSelect from '@blade/common/components/device-cascader-select/index.vue';
import { getSnapImageList } from '@blade-sxp/monitor-center/api/index';
// import { getSnapImageList } from '@blade-sxp/monitor-center/api/index';
// import { getSnapImageList } from '@blade-sxp/business-portal/api/business-portal/index';
// import { fetchDeviceTree } from '@blade-sxp/monitor/api/device-management/control';
// import { isEmpty, map } from 'lodash';
import moment from 'moment';
import FoldCarousel from '@blade-sxp/monitor-center/pages/components/carousel/fold-carousel.vue';
import OpenCarousel from '@blade-sxp/monitor-center/pages/components/carousel/open-carousel.vue';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
let default_1 = class default_1 extends Vue {
    form = {
        deviceId: [],
        dates: [],
    };
    size = 30;
    ws;
    deviceIdArr = [];
    open = false;
    moment = moment;
    imgList = [];
    timer;
    time = 0;
    timerNum;
    showContent = false;
    propData = {
        deviceIdArr: [''],
        startTime: '',
        endTime: '',
    };
    wsDataArr = [];
    wsInitFns = [];
    wsUrl = '';
    updateTime = Date.now();
    loading = true;
    suspend = false;
    endTime = '';
    selectedDeviced;
    formChange(stringArr) {
        this.deviceIdArr = [];
        stringArr.forEach((item) => {
            if (item !== '') {
                this.deviceIdArr.push(item);
            }
        });
        if (this.deviceIdArr.length > 0) {
            this.showContent = true;
            if (this.open) {
                this.size = 100;
                this.openTime();
            }
            else {
                this.size = 30;
                this.openTime();
            }
            this.websocketSendMessage(this.deviceIdArr);
        }
        else {
            this.websocketCloseMessage(this.deviceIdArr);
            this.showContent = false;
        }
    }
    openChange(open) { }
    openTime() {
        this.loading = false;
        this.getSnapImageListNoTime();
    }
    websocketSendMessage(ids) {
        const params = {
            requestId: '7NREgwyBCDEGJya1YwKoT8siOPR',
            requestType: 'SUBSCRIBE',
            // operationType: 'REAL_TIME_SNAP_PICTURES_DEVICES',
            // realTimeSnapPicturesDevices: {
            //   value: [...ids],
            // },
            subscribeModel: 'DEFAULT',
            // "subscribeScript":"#{#deviceId}==‘1’ or #{#deviceId}==‘2’  or #{#deviceId}==‘3’  or #{#deviceId}==‘4’"
            subscribeScript: {
                messageSubscribeScript: ids.map((id) => `#{#deviceId}=='${id}'`).join(' or '),
                subscribeMessageType: [],
                // "subscribeMessageType":["SNAP_IMAGE_REALTIME"]
            },
        };
        if (this.ws) {
            this.ws.ws.send(JSON.stringify(params));
        }
        else {
            this.wsInitFns.push(() => {
                this.ws.ws.onopen = () => {
                    this.ws.ws.send(JSON.stringify(params));
                };
            });
        }
    }
    websocketCloseMessage(ids) {
        if (this.ws) {
            const params = {
                requestId: '7NREgwyBCDEGJya1YwKoT8siOPR',
                requestType: 'UNSUBSCRIBE',
                subscribeModel: 'DEFAULT',
                subscribeScript: {
                    messageSubscribeScript: ids.map((id) => `#{#deviceId}=='${id}'`).join(' or '),
                    subscribeMessageType: [],
                },
            };
            this.ws?.ws.send(JSON.stringify(params));
        }
    }
    clickOpen() {
        this.open = !this.open;
        if (this.open) {
            this.size = 100;
            this.openTime();
        }
        else {
            this.loading = true;
            this.size = 30;
            this.openTime();
        }
    }
    getSnapImageListNoTime() {
        const startTime = moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss');
        if (!this.endTime) {
            this.endTime = moment().format('yyyy-MM-DD HH:mm:ss');
        }
        // 调试 后期删除
        if (this.deviceIdArr.length === 0) {
            this.showContent = false;
            return;
        }
        const param = {
            deviceIds: this.deviceIdArr,
            endTime: this.endTime,
            page: 0,
            size: this.size,
            startTime: startTime,
        };
        getSnapImageList(param).then((res) => {
            if (res.list && res.list.length > 0) {
                this.imgList = res.list;
                this.showContent = true;
                this.propData = {
                    startTime: startTime,
                    endTime: this.endTime,
                    deviceIdArr: this.deviceIdArr,
                };
            }
            else {
                this.showContent = false;
            }
        });
    }
    mounted() {
        this.wsUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.VUE_APP_REALTIME_WS
                : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`;
        this.initWebSocket();
        //  EventBus.$on('DEVICE_ID_CHANGE', this.wsOnMessage);
    }
    initWebSocket() {
        this.ws = new AlarmWebsocket(this.wsUrl);
        while (this.wsInitFns.length) {
            const fn = this.wsInitFns.shift();
            fn();
        }
        this.ws.setOnMessage(this.websocketonmessage);
    }
    websocketonmessage(e) {
        if (!/{.*}/g.test(e.data))
            return;
        const data = e.data && JSON.parse(e.data);
        if (!data || data.messageType !== 'SNAP_IMAGE_REALTIME')
            return;
        const { content } = data;
        this.wsOnMessage(content);
    }
    wsOnMessage(content) {
        if (!this.suspend) {
            if (this.imgList.find((e) => e.objectId !== content.objectId && String(e.deviceId === content.deviceId))) {
                this.wsDataArr.unshift(content);
                this.timer = setTimeout(() => {
                    this.updateData();
                    this.timer = undefined;
                }, 1000);
                this.updateData();
            }
        }
    }
    updateData() {
        if (Date.now() - this.updateTime > 1000) {
            clearTimeout(this.timer);
            this.imgList = [...this.wsDataArr, ...this.imgList].slice(0, this.size);
            this.updateTime = Date.now();
            this.wsDataArr = [];
        }
    }
    beforeDestroy() {
        if (!this.deviceIdArr.length)
            return;
        this.closeWs();
        clearInterval(this.timerNum);
    }
    closeWs() {
        this.websocketCloseMessage(this.deviceIdArr);
        this.ws?.close();
    }
    mouseEnter() {
        this.size = 100;
        this.getSnapImageListNoTime();
        this.open = true;
    }
    mouseEnterOpen() {
        this.suspend = true;
    }
    mouseLeave() {
        this.suspend = false;
    }
};
__decorate([
    Prop()
], default_1.prototype, "selectedDeviced", void 0);
__decorate([
    Watch('selectedDeviced', { deep: true, immediate: true })
], default_1.prototype, "formChange", null);
__decorate([
    Watch('open', { immediate: false })
], default_1.prototype, "openChange", null);
default_1 = __decorate([
    Component({
        name: 'SnapPicture',
        components: {
            'cascader-select': cascaderSelect,
            'fold-carousel': FoldCarousel,
            OpenCarousel,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
